import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {isBefore, isAfter, addMonths, subMonths} from 'ag-common/facades'
import DatePickerHeader from './Parts/DatePickerHeader'
import DatePickerKWColumn from './Parts/DatePickerKWColumn'
import DatePickerCalendar from './Parts/DatePickerCalendar'

export const PickerMode = {
  start: 'start',
  end: 'end',
}

export default class DatePicker extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentShownMonth: props.startMonth,
      start: props.initialSelectedStart,
      end: props.initialSelectedEnd,
    }
  }

  onPrev = () => {
    const {currentShownMonth} = this.state
    this.setState({
      currentShownMonth: subMonths(currentShownMonth, 1),
    })
  }

  onNext = () => {
    const {currentShownMonth} = this.state
    this.setState({
      currentShownMonth: addMonths(currentShownMonth, 1),
    })
  }

  onCalendarCellClicked = cellDate => {
    const {pickerMode, onRangeChanged} = this.props
    const {start, end} = this.state
    if (pickerMode === PickerMode.start) {
      if (isAfter(cellDate, end)) {
        this.setState({
          start: cellDate,
          end: cellDate,
        })
        onRangeChanged(cellDate, cellDate)
      } else {
        this.setState({
          start: cellDate,
        })
        onRangeChanged(cellDate, end)
      }
    } else if (pickerMode === PickerMode.end) {
      if (isBefore(cellDate, start)) {
        this.setState({
          start: cellDate,
          end: cellDate,
        })
        onRangeChanged(cellDate, cellDate)
      } else {
        this.setState({
          end: cellDate,
        })
        onRangeChanged(start, cellDate)
      }
    }
  }

  render() {
    const {currentShownMonth, start, end} = this.state
    return (
      <div className="date-picker">
        <DatePickerHeader onLeftClick={this.onPrev} onRightClick={this.onNext} date={currentShownMonth} />
        <div className="date-picker-content-container">
          <DatePickerKWColumn date={currentShownMonth} />
          <DatePickerCalendar
            showDate={currentShownMonth}
            startDate={start}
            endDate={end}
            onCellClicked={this.onCalendarCellClicked}
          />
        </div>
      </div>
    )
  }
}

DatePicker.propTypes = {
  pickerMode: PropTypes.oneOf(_.values(PickerMode)),
  startMonth: PropTypes.instanceOf(Date),
  initialSelectedStart: PropTypes.instanceOf(Date),
  initialSelectedEnd: PropTypes.instanceOf(Date),
  onRangeChanged: PropTypes.func,
}
